var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSave = function SvgSave(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    fillRule: "evenodd",
    d: "M18.357 20c.631 0 1.143-.512 1.143-1.143V9.045c0-.303-.12-.594-.335-.808l-3.902-3.902A1.14 1.14 0 0 0 14.455 4H5.643C5.012 4 4.5 4.512 4.5 5.143v13.714c0 .631.512 1.143 1.143 1.143zm-6.286-1.714a3.286 3.286 0 1 0 0-6.572h-.142a3.286 3.286 0 1 0 0 6.572zM6.643 5.714h6.428V8a1 1 0 0 1-1 1H7.643a1 1 0 0 1-1-1z",
    clipRule: "evenodd"
  })));
};
export default SvgSave;